module.exports = __webpack_public_path__ + "static/media/1-2.14a8fc5b.png";